import React, { Fragment, useState, useEffect, useContext, useMemo, useCallback } from 'react';
import MetaTags from 'react-meta-tags';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Content from '../sections/hometwo/Content';
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowCircleDown, ArrowCircleUp, QuestionAnswer } from "@mui/icons-material";
import { createGlobalStyle } from "styled-components";
import Dashboard from '../sections/userdash/Content';
import { AuthContent } from '../pages/Login';



import { MyFileUploader } from '../MyFileUploader'
import { AppContext, defaultSiteName } from '../../AppContext';
import useLocalStorage from "use-local-storage";
import moment from "moment";

import Banner from '../sections/hometwo/Banner';
import Contactus from '../sections/hometwo/Contactus';


import Intro from '../sections/hometwo/Intro';
import Aboutus from '../sections/hometwo/Aboutus';
import Services from '../sections/hometwo/Services';
import Loancalculator from '../sections/hometwo/Loancalculator';
import Loanplans from '../sections/hometwo/Loanplans';
import Testimonials from '../sections/hometwo/Testimonials';
import Faqs from '../sections/hometwo/Faqs';
import Advertisement from '../layouts/Advertisement';
import Bookappointment from '../layouts/Bookappointment';
import Team from '../sections/hometwo/Team';
import Downloadapp from '../sections/hometwo/Downloadapp';
import Blog from '../sections/hometwo/Blog';


import {
    getDataDB,
    saveDataDB,
    modifyDataModel,
    modifyTextAI,
    countWords,
    isDescriptionField,
    isImageField,
    handleFontAwesomeRedirect
} from "../../api";

const Hometwo = () => {
    const pagelocation = 'Homepage';
    const { appState, setAppState } = useContext(AppContext);
    // const [modalOpen, setModalOpen] = useState(false);
    const [editItem, setEditItem] = useState({});
    const [loading, setLoading] = useState(false);
    // console.log("location", location);
    const {
        modalOpen = false,
        defaultConfig,
        newTextColor = "#000000",
        newButtonsColor,
        listMenu = {},
        duplicates = [],
        editSection = "",
        editItemMain = {},
        newBgColor,
        hidden = [],
        editMode = false,
        siteName = "banking-v1",
        header,
        banner,
        intro,
        aboutus,
        services,
        loancalculator,
        advertisement,
        team,
        bookappointment,
        testimonials,
        faqs,
        contactus,
        footer,
        dashboard,
        login,
        myorder = [
            "header",
            "banner",
            "intro",
            "aboutus",
            "services",
            "loancalculator",
            "advertisement",
            "team",
            "bookappointment",
            "testimonials",
            "faqs",
            "dashboard",
            "login",
            "footer"
        ]
        // #ea6645
    } = appState;

    const handleColorChange = useCallback(
        async (e) => {
            const newColor = e.target.value;
            if (!newColor) {
                return;
            }
            appState["newBgColor"] = newColor;
            // alert(appState?.newBgColor)
            delete appState?.editSection;
            delete appState?.section;
            delete appState?.editMode;
            delete appState?.siteName;
            delete appState?.configVersions;
            setAppState((existing) => {
                return {
                    ...existing,
                    newBgColor: newColor,
                };
            });
            //todo:fateh
            // document.querySelectorAll(".bg-dark-1").forEach((element) => {
            //     element.style.backgroundColor = newColor;
            // });
            // document.body.style.backgroundColor = newColor;
            // document.documentElement.style.setProperty("--bg-dark-1", newColor);
        },
        [appState]
    );

    const handleTextColor = useCallback(
        async (e) => {
            const newColor = e.target.value;
            if (!newColor) {
                return;
            }
            appState["newTextColor"] = newColor;
            delete appState?.editSection;
            delete appState?.section;
            delete appState?.editMode;
            delete appState?.siteName;
            delete appState?.configVersions;
            setAppState((existing) => {
                return {
                    ...existing,
                    newTextColor: newColor,
                };
            });
        },
        [appState]
    );

    const handleButtonColor = useCallback(async (e) => {
        const newColor = e.target.value;
        if (!newColor) {
            return;
        }
        appState["newButtonsColor"] = newColor;
        delete appState?.editSection;
        delete appState?.section;
        delete appState?.editMode;
        delete appState?.siteName;
        delete appState?.configVersions;
        setAppState((existing) => {
            return {
                ...existing,
                newButtonsColor: newColor,
            };
        });
    }, [appState]);

    useEffect(() => {
        // alert(newBgColor)
        document.querySelectorAll(".bg-dark-1").forEach((element) => {
            element.style.backgroundColor = newBgColor;
        });

        //todo:fateh
        // Update body background
        // document.body.style.backgroundColor = newBgColor;
        // document.getElementById("root").style.backgroundColor = newBgColor;

        // // Update any elements using the CSS variable
        // document.documentElement.style.setProperty("--bg-dark-1", newBgColor);
    }, [newBgColor]);

    const GlobalStyles = createGlobalStyle`
          body * {
            // color: ${newTextColor} !important;
            // background: ${newBgColor} !important
          }
          .accordion-item .accordion-button {
            color: ${newTextColor} !important;
          }
          a.btn-main .btn-main {
            color: ${newTextColor} !important;
            background: ${newBgColor} !important;
          }
          .home-video h1 {
          // color: ${newTextColor}
          // background: linear-gradient(0deg, #888888 0%, #0f0f0f 75%)
          }
          .modal-content * {
          color: black !important;
          background-color: white !important
          }
          .btn {
          background: ${newButtonsColor} !important
          }
        `;

    useEffect(() => {
        // alert(newBgColor)
        document.querySelectorAll(".bg-dark-1").forEach((element) => {
            element.style.backgroundColor = newBgColor;
        });

        // Update body background
        document.body.style.backgroundColor = newBgColor;

        // Update any elements using the CSS variable
        document.documentElement.style.setProperty("--bg-dark-1", newBgColor);
    }, [newBgColor]);


    const handleSave = useCallback(
        (item) => {
            // alert(JSON.stringify(item))
            if (appState?.[editSection] && Array.isArray(appState?.[editSection])) {
                const index = appState?.[editSection]?.findIndex(
                    (res) => res.id == item?.id
                );
                appState[editSection][
                    index >= 0 ? index : appState?.[editSection]?.length + 1
                ] = item;
            } else if (
                appState?.[editSection] &&
                typeof appState?.[editSection] == "object"
            ) {
                appState[editSection] = item;
            }
            delete appState?.editSection;
            delete appState?.section;
            delete appState?.editMode;
            delete appState?.siteName;
            delete appState?.configVersions;

            // console.log('cccccc', 2222, editSection, appState?.[editSection])
            // return
            if (appState)
                saveDataDB({
                    query: {
                        date: moment(),
                        config: appState,
                        siteName: siteName,
                    },
                    keys: ["siteName"],
                    resource: "vare_banking_site",
                }).then((info) => {
                    setEditItem({});
                    setAppState((existing) => {
                        return {
                            ...existing,
                            ...info?.[0]?.config,
                            editItemMain: {},
                            section: "",
                        };
                    });
                    setLoading(false);
                    // console.log('cccccc', info?.[0]?.config,)
                });
        },
        [editSection]
    );

    const handleSaveConfig = ({ section, config }) => {

        setAppState((existing) => {
            return {
                ...existing,
                modalOpen: true,
                editItemMain: config,
                editSection: section,
            };
        });
    };

    const mainComponent = useMemo(() => {
        const temp = [
            {
                name: "header",
                component: <div style={{
                    // display: 'flex',
                    // position: "relative",
                    // zIndex: 3,
                }}>
                    <Header />
                </div>,
                onClick: () => {
                    handleSaveConfig({
                        section: "header",
                        config: header || {},
                    });
                },
            },
            {
                name: "banner",  //todo:fateh May13th - make menu show
                component: <div style={{
                    // display: 'flex',
                    // position: "relative",
                    // zIndex: 2,
                }}><Banner /></div>,
                onClick: () => {
                    handleSaveConfig({
                        section: "banner",
                        config: banner || {},
                    });
                },
            },
            {
                name: "intro",
                component: <Intro />,
                onClick: () => {
                    handleSaveConfig({
                        section: "intro",
                        config: intro || {},
                    });
                },
            },
            {
                name: "aboutus",
                component: <Aboutus />,
                onClick: () => {
                    handleSaveConfig({
                        section: "aboutus",
                        config: aboutus || {},
                    });
                },
            },
            {
                name: "services",
                component: <Services />,
                onClick: () => {
                    handleSaveConfig({
                        section: "services",
                        config: services || {},
                    });
                },
            },
            {
                name: "loancalculator",
                component: <Loancalculator />,
                onClick: () => {
                    handleSaveConfig({
                        section: "loancalculator",
                        config: loancalculator || {},
                    });
                },
            },
            {
                name: "advertisement",
                component: <Advertisement />,
                onClick: () => {
                    handleSaveConfig({
                        section: "advertisement",
                        config: advertisement || {},
                    });
                },
            },
            {
                name: "team",
                component: <Team />,
                onClick: () => {
                    handleSaveConfig({
                        section: "team",
                        config: team || {},
                    });
                },
            },
            {
                name: "bookappointment",
                component: <Bookappointment />,
                onClick: () => {
                    handleSaveConfig({
                        section: "bookappointment",
                        config: bookappointment || {},
                    });
                },
            },
            {
                name: "testimonials",
                component: <Testimonials />,
                onClick: () => {
                    handleSaveConfig({
                        section: "testimonials",
                        config: testimonials || {},
                    });
                },
            },
            {
                name: "faqs",
                component: <Faqs />,
                onClick: () => {
                    handleSaveConfig({
                        section: "faqs",
                        config: faqs || {},
                    });
                },
            },
            {
                name: "contactus",
                component: <Contactus />,
                onClick: () => {
                    handleSaveConfig({
                        section: "contactus",
                        config: contactus || {},
                    });
                },
            },
            {
                name: "dashboard",
                component: <Dashboard />,
                onClick: () => {
                    handleSaveConfig({
                        section: "dashboard",
                        config: dashboard || {},
                    });
                },
            },
            {
                name: "login",
                component: <AuthContent />,
                onClick: () => {
                    handleSaveConfig({
                        section: "login",
                        config: login || {},
                    });
                },
            },

            {
                name: "footer",
                component: <Footer />,
                onClick: () => {
                    handleSaveConfig({
                        section: "footer",
                        config: footer || {},
                    });
                },
            },
        ];

        const data = [];
        myorder?.forEach((name) => {
            const info = name && temp.find((ref) => ref.name === name);
            if (info) {
                data.push(info);
            }
        });

        return data;
    }, [
        hidden,
        myorder,
        header,
        banner,
        intro,
        aboutus,
        services,
        loancalculator,
        advertisement,
        team,
        bookappointment,
        testimonials,
        faqs,
        footer,
        login,
        dashboard,
        contactus
    ]);


    return (
        <Fragment style={{
            display: 'flex',
            position: "relative",
        }}>
            <MetaTags>
                <title>Heritage Hub Federal Credit Union - React Template | {pagelocation}</title>
                <meta name="description" content="#" />
            </MetaTags>
            <div style={{
                // display: 'flex',
                // position: "relative",
            }}>
                {(modalOpen && Object.keys(editItemMain)?.[0])
                    ? <EditModal
                        item={editItemMain}
                        onSave={handleSave}
                        loading={loading}
                        setLoading={setLoading}
                        onClose={() => {
                            // setModalOpen(false);
                            setEditItem({});
                            setAppState((existing) => {
                                return {
                                    ...existing,
                                    modalOpen: false,
                                    editItemMain: {},
                                    section: "",
                                };
                            });
                        }}
                    />
                    : mainComponent?.map((res, i) => {
                        // alert(res?.name)
                        return (
                            <div key={res?.name}>
                                {editMode && (
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            zIndex: 99,
                                            alignItems: "center",
                                            flexDirection: "row",
                                            backgroundColor: "rgba(0,0,0,0.5)",
                                            marginTop: i == 0 ? 80 : 0,
                                            gap: 20,
                                        }}
                                    >
                                        <NavLink
                                            to="#"
                                            className={editMode ? "btn-line" : "btn"}
                                            id="btn-line"
                                            onClick={() => {
                                                res?.onClick();
                                            }}
                                            style={{
                                                marginLeft: 100,
                                                margin: 20,
                                            }}
                                        >
                                            {"Edit"}
                                        </NavLink>

                                        {myorder[i - 1] && (
                                            <NavLink
                                                to="#"
                                                className={editMode ? "btn-line" : "btn"}
                                                id="btn-line"
                                                onClick={() => {
                                                    if (myorder[i - 1]) {
                                                        const report = reorderArray({
                                                            array: myorder,
                                                            fromIndex: i,
                                                            toIndex: i - 1,
                                                        });
                                                        appState["myorder"] = report;
                                                        delete appState?.editSection;
                                                        delete appState?.section;
                                                        delete appState?.editMode;
                                                        delete appState?.siteName;
                                                        delete appState?.configVersions;
                                                        saveDataDB({
                                                            query: {
                                                                date: moment(),
                                                                config: appState,
                                                                siteName: siteName,
                                                            },
                                                            keys: ["siteName"],
                                                            resource: "vare_banking_site",
                                                        }).then((info) => {
                                                            setAppState((existing) => {
                                                                return {
                                                                    ...existing,
                                                                    myorder: report,
                                                                    editMode: true,
                                                                };
                                                            });
                                                        });
                                                    }
                                                }}
                                                style={{
                                                    marginLeft: 100,
                                                    margin: 20,
                                                }}
                                            >
                                                <ArrowCircleUp />
                                            </NavLink>
                                        )}

                                        {myorder[i + 1] && (
                                            <NavLink
                                                to="#"
                                                className={editMode ? "btn-line" : "btn"}
                                                id="btn-line"
                                                onClick={() => {
                                                    if (myorder[i + 1]) {
                                                        const report = reorderArray({
                                                            array: myorder,
                                                            fromIndex: i,
                                                            toIndex: i + 1,
                                                        });
                                                        appState["myorder"] = report;
                                                        delete appState?.editSection;
                                                        delete appState?.section;
                                                        delete appState?.editMode;
                                                        delete appState?.siteName;
                                                        delete appState?.configVersions;
                                                        saveDataDB({
                                                            query: {
                                                                date: moment(),
                                                                config: appState,
                                                                siteName: siteName,
                                                            },
                                                            keys: ["siteName"],
                                                            resource: "vare_banking_site",
                                                        }).then((info) => {
                                                            setAppState((existing) => {
                                                                return {
                                                                    ...existing,
                                                                    myorder: report,
                                                                    editMode: true,
                                                                };
                                                            });
                                                        });
                                                    }
                                                }}
                                                style={{
                                                    marginLeft: 100,
                                                    margin: 20,
                                                }}
                                            >
                                                <ArrowCircleDown />
                                            </NavLink>
                                        )}

                                        <NavLink
                                            to="#"
                                            className={editMode ? "btn-line" : "btn"}
                                            id="btn-line"
                                            onClick={() => {
                                                const report = insertStringAtIndex({
                                                    array: myorder,
                                                    index: i,
                                                    newItem: res?.name,
                                                });
                                                if (!duplicates?.includes(res?.name)) {
                                                    duplicates?.push(res?.name);
                                                }
                                                appState["myorder"] = report;
                                                appState["duplicates"] = duplicates;

                                                delete appState?.editSection;
                                                delete appState?.section;
                                                delete appState?.editMode;
                                                delete appState?.siteName;
                                                delete appState?.configVersions;
                                                saveDataDB({
                                                    query: {
                                                        date: moment(),
                                                        config: appState,
                                                        siteName: siteName,
                                                    },
                                                    keys: ["siteName"],
                                                    resource: "vare_banking_site",
                                                }).then((info) => {
                                                    setAppState((existing) => {
                                                        return {
                                                            ...existing,
                                                            myorder: report,
                                                            editMode: true,
                                                        };
                                                    });
                                                });
                                            }}
                                            style={{
                                                marginLeft: 100,
                                                margin: 20,
                                            }}
                                        >
                                            {"Add"}
                                        </NavLink>

                                        {duplicates?.[0] && duplicates?.includes(res.name) && (
                                            <NavLink
                                                to="#"
                                                className={editMode ? "btn-line" : "btn"}
                                                id="btn-line"
                                                onClick={() => {
                                                    const report = removeFirstMatch({
                                                        array: myorder,
                                                        target: res?.name,
                                                    });
                                                    const dupdelete =
                                                        duplicates?.includes(res?.name) &&
                                                        duplicates?.length > 0 &&
                                                        removeFirstMatch({
                                                            array: duplicates,
                                                            target: res?.name,
                                                        });

                                                    appState["myorder"] = report;
                                                    if (dupdelete) appState["duplicates"] = dupdelete;
                                                    delete appState?.editSection;
                                                    delete appState?.section;
                                                    delete appState?.editMode;
                                                    delete appState?.siteName;
                                                    delete appState?.configVersions;
                                                    saveDataDB({
                                                        query: {
                                                            date: moment(),
                                                            config: appState,
                                                            siteName: siteName,
                                                        },
                                                        keys: ["siteName"],
                                                        resource: "vare_banking_site",
                                                    }).then((info) => {
                                                        setAppState((existing) => {
                                                            return {
                                                                ...existing,
                                                                myorder: report,
                                                                editMode: true,
                                                            };
                                                        });
                                                    });
                                                }}
                                                style={{
                                                    marginLeft: 100,
                                                    margin: 20,
                                                }}
                                            >
                                                {"Delete"}
                                            </NavLink>
                                        )}

                                        <NavLink
                                            to="#"
                                            className={editMode ? "btn-line" : "btn"}
                                            id="btn-line"
                                            onClick={() => {
                                                if (hidden?.includes(res.name)) {
                                                    const report = hidden.filter(
                                                        (name) => name !== res.name
                                                    );
                                                    appState["hidden"] = report;
                                                    delete appState?.editSection;
                                                    delete appState?.section;
                                                    delete appState?.editMode;
                                                    delete appState?.siteName;
                                                    delete appState?.configVersions;
                                                    saveDataDB({
                                                        query: {
                                                            date: moment(),
                                                            config: appState,
                                                            siteName: siteName,
                                                        },
                                                        keys: ["siteName"],
                                                        resource: "vare_banking_site",
                                                    }).then((info) => {
                                                        setAppState((existing) => {
                                                            return {
                                                                ...existing,
                                                                hidden: report,
                                                                editMode: true,
                                                            };
                                                        });
                                                    });
                                                } else {
                                                    const report = [...hidden, res.name];
                                                    appState["hidden"] = report;
                                                    delete appState?.editSection;
                                                    delete appState?.section;
                                                    delete appState?.editMode;
                                                    delete appState?.siteName;
                                                    delete appState?.configVersions;
                                                    saveDataDB({
                                                        query: {
                                                            date: moment(),
                                                            config: appState,
                                                            siteName: siteName,
                                                        },
                                                        keys: ["siteName"],
                                                        resource: "vare_banking_site",
                                                    }).then((info) => {
                                                        setAppState((existing) => {
                                                            return {
                                                                ...existing,
                                                                hidden: [...hidden, res.name],
                                                                editMode: true,
                                                            };
                                                        });
                                                    });
                                                }
                                            }}
                                            style={{
                                                marginLeft: 100,
                                                margin: 20,
                                            }}
                                        >
                                            {hidden?.includes(res.name) ? "Show" : "Hide"}
                                        </NavLink>

                                        {i == 0 && (
                                            <div
                                                // to="#"
                                                className={"btn"}
                                                id="btn-line"
                                                // onClick={() => {
                                                //   res?.onClick();
                                                // }}
                                                style={{
                                                    marginLeft: 100,
                                                    margin: 20,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: 20,
                                                        zIndex: 99999,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <label
                                                        htmlFor="bgColor"
                                                        style={{
                                                            color: "white",
                                                            // marginRight: '10px'
                                                        }}
                                                    >
                                                        Background Color:
                                                    </label>
                                                    <input
                                                        type="color"
                                                        id="bgColor"
                                                        onChange={handleColorChange}
                                                        value={newBgColor}
                                                    />

                                                    <label
                                                        htmlFor="textColor"
                                                        style={{
                                                            color: "white",
                                                            // marginRight: '10px'
                                                        }}
                                                    >
                                                        Text Color:
                                                    </label>
                                                    <input
                                                        type="color"
                                                        id="textColor"
                                                        onChange={handleTextColor}
                                                        value={newTextColor}
                                                    />
                                                    <label
                                                        htmlFor="buttonsColor"
                                                        style={{
                                                            color: "white",
                                                        }}
                                                    >
                                                        Buttons Color:
                                                    </label>
                                                    <input
                                                        type="color"
                                                        id="buttonsColor"
                                                        onChange={handleButtonColor}
                                                        value={newTextColor}
                                                    />
                                                    <button
                                                        type="submit"
                                                        id="search-submit"
                                                        class="btn"
                                                        onClick={() => {
                                                            const confirmed = window.confirm(
                                                                "Are you sure you want to reset you configuration to site default?"
                                                            );
                                                            if (confirmed) {
                                                                // User clicked OK
                                                                // alert('refresh')
                                                            } else {
                                                                // User clicked Cancel
                                                                // console.log("Deletion cancelled.");
                                                            }
                                                        }}
                                                    >
                                                        <i
                                                            class="fa fa-refresh"
                                                            style={{
                                                                fontSize: 30,
                                                            }}
                                                        ></i>
                                                    </button>

                                                    <button
                                                        type="submit"
                                                        id="search-submit"
                                                        class="btn"
                                                        onClick={() => {
                                                            const confirmed = window.confirm(
                                                                "Are you sure you want to close editing?"
                                                            );
                                                            if (confirmed) {
                                                                // User clicked OK
                                                                // alert('close')
                                                                setAppState((existing) => {
                                                                    return {
                                                                        ...existing,
                                                                        editMode: false,
                                                                        section: "",
                                                                    };
                                                                });
                                                            } else {
                                                                // User clicked Cancel
                                                                // console.log("Deletion cancelled.");
                                                            }
                                                        }}
                                                    >
                                                        <i
                                                            class="fa fa-times-circle"
                                                            style={{
                                                                fontSize: 30,
                                                            }}
                                                        ></i>
                                                    </button>
                                                </div>
                                                <DefaultConfigs />
                                            </div>
                                        )}

                                        <div
                                            style={{
                                                color: "white",
                                            }}
                                        >
                                            {res.name}
                                        </div>
                                    </div>
                                )}

                                {![...hidden, 'dashboard', 'login']?.includes(res.name) && (
                                    <section
                                        style={
                                            {

                                                // display: 'flex',
                                                // // backgroundColor: 'red',
                                                // justifyContent: 'center'
                                            }
                                        }
                                    >
                                        {res?.component}
                                    </section>
                                )}
                            </div>
                        );
                    })}
            </div>

            {/*<>
             <Header />
            <Banner />
            <Intro />
            <Aboutus />
            <Services />
            <Loancalculator />
            <Loanplans /> 
            <Advertisement />
            <Team />
             <Downloadapp /> 
           <Blog /> 
            <Bookappointment />
            <Testimonials />
            <Faqs />
            <Footer />
            </> */}



        </Fragment >
    );
};

export default Hometwo;



// <EditModal
//   item={editItemMain}
//   onSave={handleSave}
//   loading={loading}
//   setLoading={setLoading}
//   onClose={() => {
//     setModalOpen(false);
//     setEditItem({});
//     setAppState((existing) => {
//       return {
//         ...existing,
//         editItemMain: {},
//         section: "",
//       };
//     });
//   }}
// />

const removeFirstMatch = ({ array, target }) => {
    const index = array.indexOf(target);
    if (index !== -1) {
        return [...array.slice(0, index), ...array.slice(index + 1)];
    }
    return array;
};

const insertStringAtIndex = ({ array, index, newItem }) => {
    return [...array.slice(0, index), newItem, ...array.slice(index)];
};

const reorderArray = ({ array, fromIndex, toIndex }) => {
    if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= array.length ||
        toIndex >= array.length
    ) {
        console.error("Invalid indices");
        return array;
    }

    const newArray = [...array];
    const [movedItem] = newArray.splice(fromIndex, 1); // Remove item from the original position
    newArray.splice(toIndex, 0, movedItem); // Insert item at the new position

    return newArray;
};


const MyMedia = ({ fieldValue, entry, handleNewFile, defaultItem = {} }) => {
    const [formInput, setFormInput] = useState({ picture: fieldValue });
    const [refreshing, setRefreshing] = useState(false);
    const [uploadNow, setUploadNow] = useState(false);
    const [allowAdd, setAllowAdd] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const imgType = ["image", "img", "src", "thumb", "full", "logo", "photo"];

    const props = {};
    useEffect(() => {
        if (formInput?.picture) {
            let key = "";
            imgType?.map((res) => {
                if (typeof entry == "object" && Object.keys(entry)?.includes(res)) {
                    key = res;
                }
            });
            if (key) {
                // alert(key + '-' + formInput?.picture)

                entry[key] = formInput.picture;
                // console.log('ssssssssxx5', entry)
                // handleNewFile(entry);
            }
        }
        setAllowAdd(
            selectedImage && selectedImage != formInput?.picture ? true : false
        );
    }, [formInput?.picture, selectedImage, entry]);

    // console.log('defaultItemxx', entry, defaultItem)
    return (
        <>
            <MyFileUploader
                {...props}
                defaultItem={entry?.["image"]}
                handleCancel={() => {
                    setSelectedImage("");
                    setFormInput({
                        ...formInput,
                        picture: entry?.image,
                    });
                }}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                imageKey={"picture"}
                aiSearchBy={"industry"}
                resource={"gaming_site_media"}
                refreshing={refreshing}
                setRefreshing={setRefreshing}
                setFormInput={setFormInput}
                formInput={formInput}
                uploadNow={uploadNow}
                allowAdd={allowAdd}
                handleSaveImage={() => {
                    setUploadNow(true);
                }}
            />
        </>
    );
};

const AiPromptBox = ({ handleText, aiLoading }) => {
    const [inputAIText, setInputAIText] = useState("");

    const onGenerate = () => {
        if (inputAIText && inputAIText?.trim()) {
            handleText(inputAIText);
            // setInputText(''); // Optionally clear the textarea after submission
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <textarea
                value={inputAIText}
                onChange={(e) => setInputAIText(e.target.value)}
                placeholder="Use AI assistance to generate contents, type in what you want"
                rows={4}
                style={{ width: "100%", padding: "10px", fontSize: "14px" }}
            />
            <button onClick={onGenerate} className="btn-main">
                {aiLoading ? "Loading..." : "Generate"}
            </button>

            <button
                onClick={() => {
                    setInputAIText("");
                }}
                className="btn-main"
            >
                Clear AI Assist
            </button>
        </div>
    );
};

export const EditModal = (props) => {
    const { item, onSave, onClose, setLoading, loading } = props;
    const { appState } = useContext(AppContext);
    const { editSection, defaultConfig = {} } = appState;
    const [myStore, setMyStore] = useLocalStorage("name", {});
    const {
        myInfo,
        // myInfo: { siteName = "banking-v1" },
    } = myStore;
    const siteName = appState?.myContext?.myInfo?.siteName || appState?.siteName || 'banking-v1';

    const [editedItem, setEditedItem] = useState(item || {});
    const [imageFiles, setImageFiles] = useState({});
    const [refreshing, setRefreshing] = useState(false);
    const [uploadNow, setUploadNow] = useState(false);
    const [formInputState, setFormInputState] = useState(false);

    const [aiLoading, setAILoading] = useState(false);
    const [fieldWithAI, setFieldWithAI] = useState(null);
    const [aILoadingNow, setAILoadingNow] = useState(false);

    const [stripeKey, setStripeKey] = useState({});

    useEffect(() => { //todo:dee add to other applications
        setEditedItem(item)
    }, [
        item
    ])




    // const handleInputChange = (key, value) => {
    //     setEditedItem((prev) => ({ ...prev, [key]: value }));
    // };

    const handleInputChange = (key, value) => {
        setEditedItem((prev) => ({ ...prev, [key]: value !== undefined && value !== null ? String(value) : '' }));
    };


    const handleNestedChange = (parentKey, nestedKey, value) => {
        setEditedItem((prev) => ({
            ...prev,
            [parentKey]: {
                ...prev[parentKey],
                [nestedKey]: value,
            },
        }));
    };

    const handleArrayChange = (arrayKey, index, key, value) => {
        const updatedArray = editedItem[arrayKey]?.map((item, i) =>
            i === index ? { ...item, [key]: value } : item
        );
        setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
    };

    const moveArrayItem = (arrayKey, index, direction) => {
        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= editedItem[arrayKey].length) return;

        const updatedArray = [...editedItem[arrayKey]];
        [updatedArray[index], updatedArray[newIndex]] = [
            updatedArray[newIndex],
            updatedArray[index],
        ];

        setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
    };


    const addArrayItem = (arrayKey) => {
        setEditedItem((prev) => {
            const existingArray = prev[arrayKey] || [];

            // Try to get a sample template from existing items or the default config
            let templateSource = existingArray.find(
                (item) => typeof item === "object"
            );

            if (!templateSource) {
                templateSource = defaultConfig?.[editSection]?.[arrayKey]?.[0] || {};
            }

            const generateEmptyValue = (value) => {
                if (typeof value === "number") return 0;
                if (typeof value === "boolean") return false;
                if (Array.isArray(value)) return [];
                if (typeof value === "object" && value !== null) {
                    return Object.fromEntries(
                        Object.entries(value).map(([k, v]) => [k, generateEmptyValue(v)])
                    );
                }
                return "";
            };

            const newItem = Object.fromEntries(
                Object.entries(templateSource).map(([k, v]) => [
                    k,
                    k === "id" ? existingArray.length + 1 : generateEmptyValue(v),
                ])
            );

            return {
                ...prev,
                [arrayKey]: [...existingArray, newItem],
            };
        });
    };
    const [removedItemIds, setRemovedItemIds] = useState({});

    // const removeArrayItem = (arrayKey, index) => {
    //     setEditedItem((prev) => ({
    //         ...prev,
    //         [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
    //     }));
    // };
    const removeArrayItem = (arrayKey, index) => {
        setEditedItem((prev) => ({
            ...prev,
            [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
        }));

        // Update the defaultConfig in-place to reflect the deletion
        if (defaultConfig?.[editSection]?.[arrayKey]) {
            defaultConfig[editSection][arrayKey] = defaultConfig[editSection][arrayKey].filter((_, i) => i !== index);
        }
    };


    const isDefault = useMemo(() => {
        return (
            JSON.stringify(defaultConfig[editSection]) == JSON.stringify(editedItem)
        );
    }, [appState, editSection, editedItem]);

    // const cleanedItem = useCallback((editedItem) => {
    //     return Object.fromEntries(
    //         Object.entries(editedItem).map(([k, v]) => {
    //             if (Array.isArray(v)) {
    //                 return [
    //                     k,
    //                     v.filter((entry) => Object.values(entry).some((val) => val !== "")),
    //                 ];
    //             }
    //             return [k, v];
    //         })
    //     );
    // }, []);
    // const [removedItemIds, setRemovedItemIds] = useState({});

    const cleanedItem = useCallback((editedItem) => {
        return Object.fromEntries(
            Object.entries(editedItem).map(([k, v]) => {
                if (Array.isArray(v)) {
                    const removedIds = removedItemIds[k] || [];

                    const filtered = v.filter(entry => {
                        const isRemoved = removedIds.includes(entry.id);
                        if (isRemoved) return false;

                        return Object.values(entry).some(val => {
                            if (typeof val === 'string') return val.trim() !== '';
                            if (Array.isArray(val)) return val.length > 0;
                            if (typeof val === 'object' && val !== null) return Object.keys(val).length > 0;
                            return val !== null && val !== undefined;
                        });
                    });

                    return [k, filtered];
                }
                return [k, v];
            })
        );
    }, [removedItemIds]);


    useEffect(() => { }, [fieldWithAI]);

    return (
        <div
            style={{
                width: "100%",
                zIndex: 5,
                height: "auto",
                display: "flex",
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                padding: 50,
            }}
        >
            {aILoadingNow && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 99999,
                        display: "flex",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        height: "100%",
                        width: "100%",
                        fontSize: 40,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    Loading....
                </div>
            )}
            <div
                className="modal-content"
                style={{
                    width: 500,
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    padding: 20,
                }}
            >
                <h2>{`Edit ${editSection}`}</h2>

                {editedItem?.aiAssist && (
                    <div
                        style={{
                            padding: 20,
                        }}
                    >
                        {" "}
                        <AiPromptBox
                            handleText={(text) => {
                                // alert(text)
                                setAILoading(true);
                                modifyDataModel({
                                    industry: text,
                                    dataModel: defaultConfig?.[editSection],
                                }).then((res) => {
                                    // console.log('xxxxxxxx', res)
                                    setEditedItem(res);
                                    setAILoading(false);
                                });
                            }}
                            aiLoading={aiLoading}
                        />
                    </div>
                )}

                {!isDefault && (
                    <button
                        className="btn-main"
                        onClick={() => setEditedItem(defaultConfig[editSection])}
                        style={{
                            marginLeft: 30,
                            marginRight: 30,
                        }}
                    >
                        Reset to Default
                    </button>
                )}

                {Object.entries(editedItem)?.map(([key, value], index) => {
                    if (
                        // key === "menu" &&
                        typeof value === "boolean"
                    ) {
                        return (
                            <div
                                key={key}
                                style={{ display: "flex", alignItems: "center", gap: 10 }}
                            >
                                <label style={{ minWidth: "100px" }}>{key}</label>
                                <input
                                    type="checkbox"
                                    checked={value}
                                    onChange={(e) => handleInputChange(key, e.target.checked)}
                                />
                            </div>
                        );
                    }
                    if (Array.isArray(value)) {
                        return (
                            <div
                                key={key}
                                style={{ display: "flex", flexDirection: "column", gap: 10 }}
                            >
                                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                                {value.map((entry, index) => (
                                    <div
                                        key={entry.id ?? index}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 5,
                                            borderBottom: "1px solid #ddd",
                                            paddingBottom: 10,
                                        }}
                                    >
                                        {Object.entries(entry)?.map(([field, fieldValue]) => {
                                            const isDate = field.toLowerCase() == "date" || field == "endDate";
                                            if (field !== "id") {
                                                if (
                                                    Array.isArray(fieldValue) &&
                                                    fieldValue.every((v) => typeof v === "object")
                                                ) {
                                                    return (
                                                        <div
                                                            key={field}
                                                            style={{
                                                                marginLeft: 20,
                                                                borderLeft: "2px solid #eee",
                                                                paddingLeft: 10,
                                                            }}
                                                        >
                                                            <label style={{ fontWeight: "bold" }}>
                                                                {field.charAt(0).toUpperCase() + field.slice(1)}
                                                            </label>
                                                            {fieldValue.map((subItem, subIndex) => (
                                                                <div
                                                                    key={subIndex}
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 5,
                                                                        marginBottom: 5,
                                                                    }}
                                                                >
                                                                    {Object.entries(subItem).map(
                                                                        ([subKey, subValue]) => (
                                                                            <div
                                                                                key={subKey}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 10,
                                                                                }}
                                                                            >
                                                                                <label style={{ minWidth: "60px" }}>
                                                                                    {subKey}
                                                                                </label>
                                                                                <input
                                                                                    type={
                                                                                        subKey == "Day" ? "datetime-local" : "text"
                                                                                    }
                                                                                    value={subValue}
                                                                                    onChange={(e) => {
                                                                                        const updatedArray = [
                                                                                            ...editedItem[key],
                                                                                        ];
                                                                                        updatedArray[index][field][
                                                                                            subIndex
                                                                                        ][subKey] = e.target.value;
                                                                                        setEditedItem((prev) => ({
                                                                                            ...prev,
                                                                                            [key]: updatedArray,
                                                                                        }));
                                                                                    }}
                                                                                    style={{ flex: 1 }}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    )}
                                                                    <button
                                                                        onClick={() => {
                                                                            const updatedArray = [...editedItem[key]];
                                                                            updatedArray[index][field] = updatedArray[
                                                                                index
                                                                            ][field].filter((_, i) => i !== subIndex);
                                                                            setEditedItem((prev) => ({
                                                                                ...prev,
                                                                                [key]: updatedArray,
                                                                            }));
                                                                        }}
                                                                        style={{
                                                                            color: "red",
                                                                            border: "none",
                                                                            background: "none",
                                                                            alignSelf: "flex-start",
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            ))}
                                                            <button
                                                                onClick={() => {
                                                                    const updatedArray = [...editedItem[key]];
                                                                    updatedArray[index][field] = [
                                                                        ...updatedArray[index][field],
                                                                        { name: "" },
                                                                    ];
                                                                    setEditedItem((prev) => ({
                                                                        ...prev,
                                                                        [key]: updatedArray,
                                                                    }));
                                                                }}
                                                            >
                                                                Add Item
                                                            </button>
                                                        </div>
                                                    );
                                                }
                                                return (
                                                    <div
                                                        key={field}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 10,
                                                            }}
                                                        >
                                                            <label style={{ minWidth: "80px" }}>
                                                                {field.charAt(0).toUpperCase() + field.slice(1)}
                                                            </label>
                                                            <input
                                                                // type="text"
                                                                type={isDate ? "datetime-local" : "text"}
                                                                value={fieldValue}
                                                                onChange={(e) =>
                                                                    handleArrayChange(
                                                                        key,
                                                                        index,
                                                                        field,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                style={{ flex: 1 }}
                                                            />
                                                            {!isImageField(`${field}`) &&
                                                                typeof fieldValue === 'string'
                                                                && !fieldValue.includes(".com")
                                                                && isDescriptionField(`${field}`)
                                                                && (
                                                                    <button
                                                                        onClick={() => {
                                                                            modifyTextAI({
                                                                                text: fieldValue,
                                                                                length: fieldValue ? countWords(fieldValue) : 10,
                                                                            }).then((res) => {
                                                                                // alert(JSON.stringify(res))
                                                                                if (res) {
                                                                                    handleArrayChange(
                                                                                        key,
                                                                                        index,
                                                                                        field,
                                                                                        res
                                                                                    )
                                                                                }
                                                                            });
                                                                        }}
                                                                        style={{
                                                                            // background: "none",
                                                                            border: "none",
                                                                            cursor: "pointer",
                                                                            backgroundColor: "blue",
                                                                            color: "white",
                                                                        }}
                                                                        title="Generate with AI"
                                                                    >
                                                                        AI (Task)
                                                                    </button>
                                                                )}
                                                            {field == 'icon' && (
                                                                <QuestionAnswer
                                                                    onClick={() => {
                                                                        handleFontAwesomeRedirect()
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                        {isImageField(field) && (
                                                            <MyMedia
                                                                fieldValue={fieldValue}
                                                                entry={entry}
                                                                handleNewFile={() => { }}
                                                                defaultItem={defaultConfig[editSection]}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}

                                        <div
                                            style={{ display: "flex", alignItems: "center", gap: 10 }}
                                        >
                                            <label>ID</label>
                                            <input
                                                type="number"
                                                value={entry.id}
                                                readOnly
                                                style={{ width: 60, textAlign: "center" }}
                                            />
                                            <button
                                                onClick={() => moveArrayItem(key, index, -1)}
                                                disabled={index === 0}
                                            >
                                                &uarr;
                                            </button>
                                            <button
                                                onClick={() => moveArrayItem(key, index, 1)}
                                                disabled={index === value.length - 1}
                                            >
                                                &darr;
                                            </button>
                                        </div>

                                        <button
                                            onClick={() => removeArrayItem(key, index)}
                                            style={{
                                                backgroundColor: "red",
                                                color: "white",
                                                border: "none",
                                                padding: "5px 10px",
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button
                                    onClick={() =>
                                        addArrayItem(key, {
                                            title: "",
                                            header: "",
                                            price: "",
                                            image: "",
                                            description: "",
                                        })
                                    }
                                    className="btn-main"
                                >
                                    Add {key.slice(0, -1)}
                                </button>
                            </div>
                        );
                    }

                    if (typeof value === "object" && value !== null) {
                        return (
                            <div
                                key={key}
                                style={{ display: "flex", flexDirection: "column", gap: 10 }}
                            >
                                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                                {Object.entries(value)?.map(([nestedKey, nestedValue]) => (
                                    <div
                                        key={nestedKey}
                                        style={{ display: "flex", flexDirection: "column", gap: 5 }}
                                    >
                                        <div
                                            style={{ display: "flex", alignItems: "center", gap: 10 }}
                                        >
                                            <label style={{ minWidth: "80px" }}>{nestedKey}</label>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flex: 1,
                                                    gap: 5,
                                                }}
                                            >

                                                <textarea
                                                    value={nestedValue}
                                                    onChange={(e) =>
                                                        handleNestedChange(key, nestedKey, e.target.value)
                                                    }
                                                    style={{
                                                        flex: 1,
                                                        height: "1.5em", // height of one line (adjust as needed)
                                                        lineHeight: "1.5em", // ensure vertical centering
                                                        overflowY: "auto",
                                                        resize: "vertical",
                                                    }}
                                                />
                                                {!isImageField(`${key}.${nestedKey}`) &&
                                                    !nestedValue?.includes(".com")
                                                    && isDescriptionField(`${key}.${nestedKey}`)
                                                    && (
                                                        <button
                                                            onClick={() => {
                                                                modifyTextAI({
                                                                    text: nestedValue,
                                                                    length: value ? countWords(value) + 20 : 100,
                                                                }).then((res) => {
                                                                    // alert(JSON.stringify(res))
                                                                    if (res)
                                                                        handleNestedChange(key, nestedKey, res);
                                                                });
                                                            }}
                                                            style={{
                                                                // background: "none",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                backgroundColor: "blue",
                                                                color: "white",
                                                            }}
                                                            title="Generate with AI"
                                                        >
                                                            AI (Task)
                                                        </button>
                                                    )}
                                                {`${key}.${nestedKey}` == 'icon' && (
                                                    <QuestionAnswer
                                                        onClick={() => {
                                                            handleFontAwesomeRedirect()
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        {isImageField(nestedValue) && (
                                            <MyMedia
                                                fieldValue={nestedValue}
                                                entry={value}
                                                handleNewFile={() => { }}
                                                defaultItem={defaultConfig[editSection]}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        );
                    }

                    return (
                        <div
                            key={key}
                            style={{ display: "flex", flexDirection: "column", gap: 5 }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <label style={{ minWidth: "100px" }}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flex: 1,
                                        gap: 5,
                                    }}
                                >
                                    <textarea
                                        value={value || ''}
                                        onChange={(e) => handleInputChange(key, e.target.value)}
                                        style={{
                                            flex: 1,
                                            height:
                                                value && countWords(String(value)) > 5 ? '4.5em' : '1.5em', // convert value to string here
                                            lineHeight: '1.5em',
                                            overflowY: 'auto',
                                            resize: 'vertical',
                                        }}
                                    />

                                    {!isImageField(key) &&
                                        !value?.includes(".com") && (
                                            <button
                                                onClick={() => {
                                                    setAILoadingNow(true);
                                                    modifyTextAI({
                                                        text: value,
                                                        length: value ? countWords(value) + 20 : 100,
                                                    }).then((res) => {
                                                        // alert(JSON.stringify(res))
                                                        if (res) {
                                                            handleInputChange(key, res);
                                                        }
                                                        setAILoadingNow(false);
                                                    });
                                                }}
                                                style={{
                                                    // background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    backgroundColor: "blue",
                                                    borderRadius: 100,
                                                    color: "white",
                                                }}
                                                title="Generate with AI"
                                            >
                                                AI (Task)
                                            </button>
                                        )}
                                    {key == 'icon' && (
                                        <QuestionAnswer
                                            onClick={() => {
                                                handleFontAwesomeRedirect()
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            {isImageField(key) && (
                                <MyMedia
                                    fieldValue={value}
                                    entry={editedItem}
                                    handleNewFile={() => { }}
                                    defaultItem={defaultConfig[editSection]}
                                />
                            )}
                        </div>
                    );
                })}

                {(editSection == "pricings" || editSection == "pricelists") &&
                    myInfo?.token && (
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flex: 1,
                                    gap: 5,
                                    flexDirection: "column",
                                    width: "100%",
                                }}
                            >
                                <textarea
                                    // type="text"
                                    // type="password"
                                    value={stripeKey["key"] || ""}
                                    onChange={(e) => {
                                        setStripeKey({
                                            ...stripeKey,
                                            key: e.target.value,
                                        });
                                    }}
                                    style={{
                                        flex: 1,
                                        height:
                                            stripeKey["key"] && countWords(stripeKey["key"]) > 5
                                                ? "4.5em"
                                                : "1.5em", // height of one line (adjust as needed)
                                        lineHeight: "1.5em", // ensure vertical centering
                                        overflowY: "auto",
                                        resize: "vertical",
                                        width: "100%",
                                    }}
                                />

                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flex: 1,
                                    gap: 5,
                                    flexDirection: "column",
                                    width: "100%",
                                }}
                            >

                                <textarea
                                    // type="password"
                                    value={stripeKey["productId"] || ""}
                                    onChange={(e) => {
                                        setStripeKey({
                                            ...stripeKey,
                                            productId: e.target.value,
                                        });
                                    }}
                                    style={{
                                        flex: 1,
                                        height:
                                            stripeKey["productId"] &&
                                                countWords(stripeKey["productId"]) > 5
                                                ? "4.5em"
                                                : "1.5em", // height of one line (adjust as needed)
                                        lineHeight: "1.5em", // ensure vertical centering
                                        overflowY: "auto",
                                        resize: "vertical",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </div>
                    )}

                <div style={{
                    position: "fixed",
                    top: 20,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: "10px",
                    zIndex: 10,
                    backgroundColor: "#fff", // optional: white background
                    padding: "10px 20px",     // optional: spacing around buttons
                    borderTop: "1px solid #ddd", // optional: top border
                    boxShadow: "0 -2px 5px rgba(0,0,0,0.1)", // optional: subtle shadow
                }}>
                    <button
                        disabled={loading}
                        style={
                            loading
                                ? {
                                    backgroundColor: "red",
                                }
                                : {}
                        }
                        onClick={async () => {
                            // if (stripeKey?.productId && stripeKey?.key) {
                            saveDataDB({
                                query: {
                                    date: moment(),
                                    handle: myInfo?.handle,
                                    siteName: siteName,
                                    config: cleanedItem(editedItem)
                                },
                                keys: ["date", "siteName"],
                                resource: "vare_banking_versions",
                            }).then((info) => {
                                setLoading(true);
                                setUploadNow(true);
                                onSave(cleanedItem(editedItem));
                            });
                            // }

                            // setLoading(true);
                            // setUploadNow(true);
                            // onSave(cleanedItem(editedItem));
                        }}
                        className="btn-main"
                    >
                        {loading ? "Loading..." : "Save"}
                    </button>
                    <button disabled={loading} onClick={onClose} className="btn-main">
                        Cancel
                    </button>
                </div>
            </div>

            {/* <button
                    disabled={loading}
                    style={
                        loading
                            ? {
                                backgroundColor: "red",
                            }
                            : {}
                    }
                    onClick={async () => {
                        if (stripeKey?.productId && stripeKey?.key) {
                            saveDataDB({
                                query: {
                                    date: moment(),
                                    handle: myInfo?.handle,
                                    siteName: siteName,
                                    stripeKey: stripeKey,
                                },
                                keys: ["handle", "siteName"],
                                resource: "vare_user_education",
                            }).then((info) => {
                                setLoading(true);
                                setUploadNow(true);
                                onSave(cleanedItem(editedItem));
                            });
                            return;
                        }

                        setLoading(true);
                        setUploadNow(true);
                        onSave(cleanedItem(editedItem));
                    }}
                    className="btn-main"
                >
                    {loading ? "Loading..." : "Save"}
                </button>
                <button disabled={loading} onClick={onClose} className="btn-main">
                    Cancel
                </button> */}
        </div >
    );
};

const DefaultConfigs = () => {
    const { appState, setAppState } = useContext(AppContext);
    const {
        // siteName,
        configVersions = [],
    } = appState;
    const [myStore, setMyStore] = useLocalStorage("name", {});
    const {
        myInfo,
        myInfo: { siteName = "banking-error" },
    } = myStore;

    const [versionName, setVersionName] = useState(siteName || "");
    const [selectedVersion, setSelectedVersion] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSaveVersion = useCallback(async () => {
        if (!versionName.trim()) return;

        const newVersion = {
            name: versionName && versionName?.trim(),
            timestamp: new Date().toISOString(),
            config: appState,
        };

        const updatedVersions = [...configVersions, newVersion];

        setLoading(true);
        delete appState?.editSection;
        delete appState?.section;
        delete appState?.editMode;
        delete appState?.siteName;
        delete appState?.configVersions;

        await saveDataDB({
            query: {
                date: moment(),
                siteName: defaultSiteName,
                // configVersions: [
                //     defaultSiteName,
                //     ...updatedVersions?.filter((res) => res != siteName),
                // ],
            },
            keys: ["siteName"],
            resource: "vare_banking_site",
        });

        await saveDataDB({
            query: {
                date: moment(),
                siteName: `${versionName}`,
                // configVersions: [
                //     defaultSiteName,
                //     ...updatedVersions?.filter((res) => res != siteName),
                // ],
                config: appState,
            },
            keys: ["siteName"],
            resource: "vare_banking_site",
        }).then((infoTemp) => {
            console.log("eeee3333", infoTemp);
            const info = infoTemp;

            if (info?.[0]?.config) {
                setMyStore((prev) => ({
                    ...prev,
                    myInfo: {
                        ...prev?.myInfo,
                        siteName: versionName,
                    },
                }));
                setAppState({
                    myorder: [
                        "header",
                        "videoanimates",
                        "carouselState",
                        "newsEventsAbout",
                        "testimonials",
                        "academicLife",
                        "divisionsConnect",
                        "professorsGallery",
                        "partnersDonation",
                        "footer",
                    ],
                    ...info?.[0]?.config,
                    // configVersions: info?.[0]?.configVersions || [],
                    editItemMain: {},
                    section: "",
                });
            }
        });

        // setVersionName('');
        setLoading(false);
    }, [
        versionName,
        siteName,
        // appState,
        configVersions,
        // setAppState
    ]);

    const handleLoadVersion = (versionName) => {
        const version = configVersions.find((v) => v === versionName);
        alert(versionName);
        if (version) {
            // setAppState((prev) => ({
            //     ...prev,
            //     editMode: false
            // }));
            setMyStore((prev) => ({
                ...prev,
                myInfo: {
                    ...myStore?.myInfo,
                    siteName: versionName,
                },
            }));
            setSelectedVersion(versionName);
            setVersionName(versionName);
        }
    };

    const handleDeleteVersion = (nameToDelete) => {
        const updatedVersions = configVersions.filter((v) => v !== nameToDelete);
        setAppState((prev) => ({
            ...prev,
            // configVersions: updatedVersions,
        }));
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "400px",
                marginTop: "1rem",
            }}
        >
            <div style={{ marginBottom: "1rem" }}>
                <input
                    type="text"
                    placeholder="Enter version name"
                    value={versionName}
                    onChange={(e) => setVersionName(e.target.value)}
                    style={{
                        padding: "0.5rem",
                        marginRight: "0.5rem",
                        width: "250px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        color: "black",
                    }}
                />
                <button
                    onClick={handleSaveVersion}
                    disabled={loading}
                    style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#007bff",
                        color: "black",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                    }}
                >
                    {loading ? "Saving..." : "Save Version"}
                </button>
            </div>

            {/* Dropdown to load version */}
            <div>
                {configVersions?.[0] && (
                    <select
                        className="!w-[400px]"
                        value={selectedVersion}
                        onChange={(e) => handleLoadVersion(e.target.value)}
                        style={{
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            marginBottom: "1rem",
                            backgroundColor: "gray",
                        }}
                    >
                        <option value="">Select a saved version</option>
                        {configVersions?.[0] &&
                            configVersions
                                ?.filter((res) => res != siteName)
                                ?.map((version, idx) => (
                                    <option key={idx} value={version}>
                                        {version}
                                    </option>
                                ))}
                    </select>
                )}
            </div>
        </div>
    );
};
